import { Component, HostListener, OnInit } from '@angular/core';
import { OnFarmMiModel } from '../../../models/on-farm-mi.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MenuItem, Message, MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { first } from 'rxjs/internal/operators/first';
import { OnFarmMiService } from '../../../services/on-farm-mi.service';
import { ConfirmationService } from 'primeng/api';
import { saveAs } from 'file-saver'
import { FarmersApplicationService } from '../../../services/farmers-application.service';
import { FarmerLandDetailService } from '../../../services/farmer-land-detail.service';
import { FarmerLandModel, FLandModel } from 'src/app/models/farmer-land.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'on-farm-mi',
  templateUrl: './on-farm-mi.component.html',
  styleUrls: ['./on-farm-mi.component.scss']
})
export class OnFarmMiComponent implements OnInit {
  public onFarmMIForm: FormGroup;
  isSubsidyAvailabe: any;
  isExistingMIAvailable: any;
  selectedState: any;
  cities: any[];

  lstOnFarmMiModel: OnFarmMiModel[];
  onFarmMiModel: OnFarmMiModel;
  selectedOnFarmMi: OnFarmMiModel[];
  submitted: boolean;
  statuses: any[];
  valActive: any;
  productDialog: boolean;
  filteredWaterQuality: any[];
  waterQualityList = [];
  componentMasterList = [];
  filteredComponentMaster: any[];
  selectedLandDetail: any;
  items: MenuItem[];
  lstFarmerLandModel: FLandModel[];
  isLandDetailsShow: boolean;
  MorabbaNo: any;
  KillaNo: any;
  filteredLandDetails: any[];
  editFarmMiModel: OnFarmMiModel;
  selectedcompMaster: any;
  departmentList = [
    { name: 'Agriculture', code: 'Agriculture' },
    { name: 'Horticulture', code: 'Horticulture' },
    { name: 'MICADA 1.0', code: 'MICADA' },
  ];

  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  farmerPreviousSubsidies = [];
  farmerId: any;
  innerWidth: number;

  showSubsidyArea: boolean = false;
  ipAddress: any = '000.000.000';
  minDate: Date;
  maxDate: Date;
  yearArray:any[]=[]
  public loading: boolean = false;
  constructor(private flDetailService: FarmerLandDetailService, 
    private fApplicationService: FarmersApplicationService, 
    private confirmationService: ConfirmationService, 
    private primengConfig: PrimeNGConfig, 
    private service: MessageService, 
    private _formBuilder: FormBuilder, 
    private ofService: OnFarmMiService, 
    private messageService: MessageService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    ) { }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.getIP();
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = (month === 0) ? 11 : month -1;
    let prevYear = (prevMonth === 11) ? year - 8 : year-7;
    let nextMonth = (month === 11) ? 0 : month + 1;
    let nextYear = (nextMonth === 0) ? year : year;
    this.minDate = new Date();
    this.minDate.setMonth(prevMonth);
    this.minDate.setFullYear(prevYear);
    this.maxDate = new Date();
    this.maxDate.setMonth(nextMonth);
    this.maxDate.setFullYear(nextYear);
    this.innerWidth = window.innerWidth;
  //  console.log(this.minDate.getFullYear(),"minDate.............")
      for(let i=this.minDate.getFullYear();i<=this.maxDate.getFullYear();i++){
        this.yearArray.push({name:i.toString(),code:i.toString()});
      }
      // console.log(this.yearArray,"this.yearArray")
    this.items = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel();
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf();
        }
      },
    ];

    this.onFarmMIForm = this._formBuilder.group({
      yearSubsudy: ['', []],
      balanceArea: ['', [Validators.required]],
      departmentSubsidy: ['', []],
      componentMaster: ['', []],
      isSubsidyAvailabe: ['', [Validators.required]],
      landDetails: ['', [Validators.required]],
      subsidyArea: ['']
    });
    this.f.balanceArea.disable();
    this.primengConfig.ripple = true;
    this.loadOnFramMI();
    this.loadComponentMaster();
    this.loadData();
    this.getPastSubsidiesByFarmerId();
  }

  getPastSubsidiesByFarmerId() {
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';

    if (this.farmerId) {
      // this.loader.start();
      this.loading = true;
      this.ofService.GetFarmerPastSubsidyByFarmerId(this.farmerId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(mobile, 'On Farm MI', this.farmerId, new Date(), 'Success');

            this.farmerPreviousSubsidies = data;
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(mobile, 'On Farm MI', this.farmerId, new Date(), err);
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Previous Subsidies not loaded.' });
          }
        });
    }
  }


  loadData() {
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    if (farmerData) {
      // this.loader.start();
    this.loading = true;
      this.flDetailService.getNotUsedLandsByFarmerID(farmerData.Farmer_ID)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            if (data.length > 0) {
              this.lstFarmerLandModel = data;
              this.lstFarmerLandModel.forEach(function (value) {
                value.description = "Morabba: " + value.MorabbaNo + ", Killa" + value.KillaNo
              });
            }
            else{
              this.service.add({ severity: 'info', summary: 'Info Message', detail: data });
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Land Details not loaded.' });
          }
        });
    }
  }

  changeLD() {
    console.log("this.selectedLandDetail", this.selectedLandDetail)

    this.KillaNo = this.selectedLandDetail.KillaNo;
    this.MorabbaNo = this.selectedLandDetail.MorabbaNo;
    // let balanceArea = this.selectedLandDetail.TotalArea - this.f.balanceArea.value
    // this.f.balanceArea.setValue(balanceArea);
    this.f.balanceArea.setValue(0);
    this.getAreaByLandId(this.selectedLandDetail.LandID);
  }

  getAreaByLandId(landId){
    // this.loader.start();
    this.loading = true;
    this.flDetailService.getAreaByLandId(landId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            let area = data[0].Area;
            // console.log("Area", area)
            this.f.subsidyArea.setValue(area);
            this.showSubsidyArea = true;
            // this.loader.close();
            this.loading = false;
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Area is not fetched by Land Id' });
          }
        });
  }

  filterLandDetails(event: any) {
    console.log(event);

    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.lstFarmerLandModel.length; i++) {
      const wq = this.lstFarmerLandModel[i];

      if (wq.MorabbaNo.toString().indexOf(query) == 0) {
        filtered.push(wq);
      }
    }

    this.filteredLandDetails = filtered;
    console.log(this.filteredLandDetails);

  }

  loadOnFramMI() {
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    if (!farmerData) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Please complete the farmer details first.' });
      return;
    }
    this.farmerId = farmerData?.Farmer_ID;
    // this.loader.start();
    this.loading = true;
    this.ofService.GetOnFarmMi(farmerData.Farmer_ID)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          if (data.Table.length > 0) {
            this.lstOnFarmMiModel = data.Table.map(res => {
              return {
                landDetailsToDisplay: 'Village Name:' +res.VillageName + ' - Killa No:'+ res.Killa_No + ' - Morabba No:'+ res.Morabba_No,
              ...res
             }
            })
          }
          else if(data.Table.length == 0){
            this.lstOnFarmMiModel = [];
          }
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
          this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farm Mi Details not loaded.' });

        }
      });
  }

  loadWaterQuality() {
    // this.loader.start();
    this.loading = true;
    this.ofService.GetWaterQuality().subscribe(res => {
      this.waterQualityList = res;
      this.filteredWaterQuality = [...this.waterQualityList]

    })
    // this.loader.close();
    this.loading = false;
  }

  loadComponentMaster() {
    // this.loader.start();
    this.loading = true;
    this.fApplicationService.getComponentMaster().subscribe(res => {
      this.componentMasterList = res;
      this.filteredComponentMaster = [...this.componentMasterList]

    })
    // this.loader.close();
    this.loading = false;
  }

  get f() {
    return this.onFarmMIForm.controls;
  }

  filterComponentMaster(event: any) {
    console.log(event);

    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.componentMasterList.length; i++) {
      const wq = this.componentMasterList[i];
      if (wq.Program_Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(wq);
      }
    }

    this.filteredComponentMaster = filtered;
    console.log(this.filteredComponentMaster);

  }

  openNew() {
    this.editFarmMiModel = undefined;
    this.f.yearSubsudy.reset();
    this.f.balanceArea.reset();
    this.f.departmentSubsidy.reset();
    this.f.landDetails.reset();
    this.f.componentMaster.reset();
    // this.f.yearSubsudy.setValue(this.editFarmMiModel.year_subsidy);
    // this.f.balanceArea.setValue(this.editFarmMiModel.bal_Area);
    // this.f.departmentSubsidy.setValue(this.editFarmMiModel.dept_subsidy);
    // this.f.landDetails.setValue(this.editFarmMiModel.land_ID);
    this.selectedLandDetail = 0;
    this.selectedcompMaster = 0;

    this.submitted = false;
    this.productDialog = true;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.onFarmMIForm.invalid) {
      return;
    }
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    if (!farmerData) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Please complete the farmer details first.' });
      return;
    }

    this.onFarmMiModel = new OnFarmMiModel();
    this.onFarmMiModel.farmerID = farmerData.Farmer_ID;
    this.onFarmMiModel.land_ID = this.f.landDetails.value.LandID;
    this.onFarmMiModel.water_Quality = "1";
    this.onFarmMiModel.isSubsidyAvail = this.isSubsidyAvailabe;
    this.onFarmMiModel.year_subsidy = this.isSubsidyAvailabe == 1 ? this.f.yearSubsudy.value : '0';
    this.onFarmMiModel.bal_Area = this.f.balanceArea.value;
    this.onFarmMiModel.dept_subsidy = this.isSubsidyAvailabe == 1 ? this.f.departmentSubsidy.value : '';
    this.onFarmMiModel.component = this.f.componentMaster.value.Program_Id;
    this.onFarmMiModel.user_ID = sessionStorage.getItem('abyUserID') ? sessionStorage.getItem('abyUserID') : sessionStorage.getItem("userID");
    this.onFarmMiModel.network_ID = this.ipAddress;
    this.onFarmMiModel.terminal_ID = this.ipAddress;

    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';
    // console.log(this.onFarmMiModel,"this.onFarmMiModel")
    if (this.editFarmMiModel != null) {
      // this.loader.start();
      this.loading = true;
      this.onFarmMiModel.farmerID = this.editFarmMiModel.Farmer_ID;
      this.onFarmMiModel.land_ID = this.editFarmMiModel.Land_ID;
      this.ofService.UpdateOnFarmMi(this.onFarmMiModel)
        .pipe(first())
        .subscribe({
          next: (resp) => {
            // this.loader.close();
            this.loading = false;
            this.loadOnFramMI();
            this.activityRecordService.activityRecord(mobile, 'On Farm MI Updated', this.farmerId, new Date(), resp, this.onFarmMiModel);

            this.service.add({ severity: 'success', summary: 'Success Message', detail: 'Farm Mi saved Successfully.' });
            this.productDialog = false;
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(mobile, 'On Farm MI Updated', this.farmerId, new Date(), err, this.onFarmMiModel);

            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farm Mi Details not saved.' });

          }
        });
    }
    else {
      // this.loader.start();
      this.loading = true;
      this.ofService.InsertOnFarmMi(this.onFarmMiModel)
        .pipe(first())
        .subscribe({
          next: (resp) => {
            // this.loader.close();
            this.loading = false;
            this.loadOnFramMI();
            this.activityRecordService.activityRecord(mobile, 'On Farm MI Inserted', this.farmerId, new Date(), resp, this.onFarmMiModel);

            this.service.add({ severity: 'success', summary: 'Success Message', detail: 'Farm Mi saved Successfully.' });
            this.productDialog = false;
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(mobile, 'On Farm MI Inserted', this.farmerId, new Date(), err, this.onFarmMiModel);

            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farm Mi Details not saved.' });

          }
        });
    }

  }

  hideDialog() {
    this.productDialog = false;
    this.submitted = false;
    this.f.subsidyArea.reset();
    this.showSubsidyArea = false;
  }

  editProduct(bank: any) {
    this.editFarmMiModel = new OnFarmMiModel();
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    let farmMi = { ...bank };
    this.f.yearSubsudy.setValue(farmMi.Year_subsidy);
    this.f.balanceArea.setValue(farmMi.Bal_Area);
    this.f.departmentSubsidy.setValue(farmMi.Dept_Subsidy);
    this.f.landDetails.setValue(farmMi.Land_ID);
    let val = this.lstFarmerLandModel.filter(x => x.LandID == farmMi.Land_ID)[0];
    this.selectedLandDetail = val;
    this.f.componentMaster.setValue(farmMi.Component);
    this.selectedcompMaster = this.componentMasterList.filter(x => x.Program_Name == farmMi.Component)[0];
    this.isSubsidyAvailabe = farmMi.Is_Subsidy_Avail;
    this.editFarmMiModel = bank;
    this.productDialog = true;

  }
  deleteProduct(bank: OnFarmMiModel) {
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';

    // console.log('selectedcompMaster', this.selectedcompMaster);
    // console.log('deleteeeeproductdetails', bank);
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
        this.onFarmMiModel = new OnFarmMiModel();
        this.onFarmMiModel.farmerID = farmerData.Farmer_ID;
        this.onFarmMiModel.landID = bank.Land_ID;
        this.onFarmMiModel.user_ID = sessionStorage.getItem('abyUserID') ? sessionStorage.getItem('abyUserID') : sessionStorage.getItem("userID");
        this.onFarmMiModel.network_ID = this.ipAddress;
        this.onFarmMiModel.terminal_ID = this.ipAddress;
        this.onFarmMiModel.year_subsidy = bank.Year_subsidy;
        this.onFarmMiModel.component = JSON.stringify(bank.ComponentID);
        this.ofService.DeleteOnFarmMi(this.onFarmMiModel)
          .pipe(first())
          .subscribe({
            next: (res) => {
              this.service.add({ severity: 'success', summary: 'Success Message', detail: JSON. stringify(res) });
              this.activityRecordService.activityRecord(mobile, 'On Farm MI Deleted', this.farmerId, new Date(), res, this.onFarmMiModel);
              this.loadOnFramMI();

            },
            error: (err) => {
              this.service.add({ severity: 'error', summary: 'Error Message', detail: err });
              this.activityRecordService.activityRecord(mobile, 'On Farm MI Deleted', this.farmerId, new Date(), err, this.onFarmMiModel);

            }
          });
      }
    });
  }
  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.lstOnFarmMiModel);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, "onFarmMi");
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  downloadSheetAsPdf() {

    this.cols = [
      // { field: 'farmerName', header: 'Farmers Name'},
      { field: 'Land_ID', header: 'Land' },
      { field: 'Year_subsidy', header: 'Year Subsidy' },
      { field: 'Water_Quality', header: 'Water Quailty' },
      { field: 'Bal_Area', header: 'Balance Area' },
      { field: 'Dept_Subsidy', header: 'Department Subsidy' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, this.lstOnFarmMiModel);
        doc.save('onFarmMi.pdf');
      })
    })
  }

  subsidyAreachange(event: any) {
    let balanceArea = this.selectedLandDetail.Total_Area - this.f.subsidyArea.value
    this.f.balanceArea.setValue(balanceArea);
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
}
